/* @generated from adl module common.config.db */

import * as ADL from './../../runtime/adl';

export interface PostgreSqlConfig {
  host: string;
  port: number;
  dbname: string;
  user: string;
  password: string;
  poolSize: number;
  postgisEnabled: boolean;
  /**
   * The amount of time to wait before refreshing a connection
   */
  minRefreshDelayMillis: number;
  /**
   * The amount of time to wait for a free connection before timing out
   */
  connectionWaitMillis: number;
}

export function makePostgreSqlConfig(
  input: {
    host: string,
    port: number,
    dbname: string,
    user: string,
    password: string,
    poolSize?: number,
    postgisEnabled?: boolean,
    minRefreshDelayMillis?: number,
    connectionWaitMillis?: number,
  }
): PostgreSqlConfig {
  return {
    host: input.host,
    port: input.port,
    dbname: input.dbname,
    user: input.user,
    password: input.password,
    poolSize: input.poolSize === undefined ? 5 : input.poolSize,
    postgisEnabled: input.postgisEnabled === undefined ? false : input.postgisEnabled,
    minRefreshDelayMillis: input.minRefreshDelayMillis === undefined ? 60000 : input.minRefreshDelayMillis,
    connectionWaitMillis: input.connectionWaitMillis === undefined ? 5000 : input.connectionWaitMillis,
  };
}

const PostgreSqlConfig_AST : ADL.ScopedDecl =
  {"moduleName":"common.config.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"host","default":{"kind":"nothing"},"name":"host","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"port","default":{"kind":"nothing"},"name":"port","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"dbname","default":{"kind":"nothing"},"name":"dbname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"user","default":{"kind":"nothing"},"name":"user","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"password","default":{"kind":"nothing"},"name":"password","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"poolSize","default":{"kind":"just","value":5},"name":"poolSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"postgisEnabled","default":{"kind":"just","value":false},"name":"postgisEnabled","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The amount of time to wait before refreshing a connection\n"}],"serializedName":"minRefreshDelayMillis","default":{"kind":"just","value":60000},"name":"minRefreshDelayMillis","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The amount of time to wait for a free connection before timing out\n"}],"serializedName":"connectionWaitMillis","default":{"kind":"just","value":5000},"name":"connectionWaitMillis","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"PostgreSqlConfig","version":{"kind":"nothing"}}};

export const snPostgreSqlConfig: ADL.ScopedName = {moduleName:"common.config.db", name:"PostgreSqlConfig"};

export function texprPostgreSqlConfig(): ADL.ATypeExpr<PostgreSqlConfig> {
  return {value : {typeRef : {kind: "reference", value : snPostgreSqlConfig}, parameters : []}};
}

export interface SqlServerConfig {
  host: string;
  port: number;
  dbname: string;
  user: string;
  password: string;
  poolSize: number;
}

export function makeSqlServerConfig(
  input: {
    host: string,
    port: number,
    dbname: string,
    user: string,
    password: string,
    poolSize?: number,
  }
): SqlServerConfig {
  return {
    host: input.host,
    port: input.port,
    dbname: input.dbname,
    user: input.user,
    password: input.password,
    poolSize: input.poolSize === undefined ? 5 : input.poolSize,
  };
}

const SqlServerConfig_AST : ADL.ScopedDecl =
  {"moduleName":"common.config.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"host","default":{"kind":"nothing"},"name":"host","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"port","default":{"kind":"nothing"},"name":"port","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"dbname","default":{"kind":"nothing"},"name":"dbname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"user","default":{"kind":"nothing"},"name":"user","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"password","default":{"kind":"nothing"},"name":"password","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"poolSize","default":{"kind":"just","value":5},"name":"poolSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"SqlServerConfig","version":{"kind":"nothing"}}};

export const snSqlServerConfig: ADL.ScopedName = {moduleName:"common.config.db", name:"SqlServerConfig"};

export function texprSqlServerConfig(): ADL.ATypeExpr<SqlServerConfig> {
  return {value : {typeRef : {kind: "reference", value : snSqlServerConfig}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "common.config.db.PostgreSqlConfig" : PostgreSqlConfig_AST,
  "common.config.db.SqlServerConfig" : SqlServerConfig_AST
};
